module.exports = __webpack_public_path__ + "img/stock0.450c98f8.png";